export default {
  valueOfOneShare: 0,
  currencySymbol: "",
  dataVisibility: ["Self", "Super Admins"],
  esopAccessRights: {},
};
